module.exports = __webpack_public_path__ + "img/image-15.16736cc7.webp";